import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { isObject } from 'lodash'
import configment from '@adc/configment'
import {
  Button,
  Drawer,
  MEDIUM_WIDTH,
  useWindowDimensionsHook,
  constants,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import history from '../../history'
import CalendarFilters from '../calendarFilters'
import STATICS from '../../statics'
import { getStateLink, getAssetTypeLink } from '../../utils/filters'
import types from '../../constants/propTypes'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const MobileOnly = ({ children }) => {
  const { width } = useWindowDimensionsHook()
  return width < MEDIUM_WIDTH ? children : null
}

MobileOnly.propTypes = {
  children: PropTypes.element.isRequired,
}

class CalendarHeader extends Component {
  constructor(props) {
    super(props)
    const productTypeFilter =
      STATICS.AUCTION_TYPE_LIST.find(
        entry => entry.value === props.params.product_type
      ) || {}
    this.state = {
      states: [],
      stateFilter: {
        label: null,
        value: null,
      },
      productTypeFilter,
      bidEndDateFilter: null,
      buyingTypeFilter: null,
      hidePastEventsFilter: true,
      extendedFilterOpen: false,
    }
  }

  static propTypes = {
    fetchEventsAction: PropTypes.func.isRequired,
    params: types.params.isRequired,
  }

  componentDidMount() {
    const { params } = this.props

    const stateFilter =
      constants.optionLists.states.find(
        entry => entry.value === params.state
      ) || {}

    this.setState({ stateFilter })
  }

  onChangeHandler = (key, value) => {
    const nextState = Object.assign({}, this.state, {
      [key]: value,
    })

    // update url
    const basePath = configment.get('URL_BASE_PREFIX')
    if (key === 'productTypeFilter') {
      const selectedProductType = isObject(value) ? value.value : value
      history.push(
        getAssetTypeLink(basePath, selectedProductType, this.state.stateFilter)
      )
      // if the product type filter has changed track event
    } else if (key === 'stateFilter') {
      const selectedState = isObject(value) ? value.value : value
      history.push(
        getStateLink(basePath, this.state.productTypeFilter, selectedState)
      )
    }

    // This is required to avoid calling api on multiple
    // onChange events fired by the datepicker
    if (
      key !== 'bidEndDateFilter' ||
      !this.state.bidEndDateFilter ||
      !value ||
      this.state.bidEndDateFilter !== value
    ) {
      this.props.fetchEventsAction(nextState)
    }

    this.setState(nextState)
  }

  clearFilters = () => {
    const nextState = {
      stateFilter: null,
      productTypeFilter: null,
      buyingTypeFilter: null,
      bidEndDateFilter: null,
    }

    // update url
    history.push(getStateLink(configment.get('URL_BASE_PREFIX'), null, null))

    this.props.fetchEventsAction(nextState)
    this.setState(nextState)
  }

  handleExtendedFilters(extendedFilterOpen) {
    this.setState({
      extendedFilterOpen,
    })
  }

  render() {
    const {
      productTypeFilter,
      buyingTypeFilter,
      bidEndDateFilter,
      stateFilter,
      hidePastEventsFilter,
      extendedFilterOpen,
    } = this.state

    return (
      <div className={cx('u-mb-4', 'u-mt-4')}>
        <h1
          className={cx('calendar-title')}
          data-elm-id='auction_calendar_title'
        >
          {STATICS.PAGE_TITLE}
        </h1>
        <div className={cx('mobile-only')}>
          <Button
            role='secondary'
            className={cx('calendar-more-filters-button')}
            onClick={() => this.handleExtendedFilters(!extendedFilterOpen)}
            elmId='adc_calendar_filters_toggle'
          >
            {STATICS.VIEW_FILTERS}
          </Button>
          <MobileOnly>
            <Drawer
              title={STATICS.FILTERS}
              open={extendedFilterOpen}
              onClose={() => this.handleExtendedFilters(false)}
            >
              <CalendarFilters
                elmId='mobile'
                onChangeHandler={this.onChangeHandler}
                productTypeFilter={productTypeFilter}
                buyingTypeFilter={buyingTypeFilter}
                bidEndDateFilter={bidEndDateFilter}
                stateFilter={stateFilter}
                hidePastEventsFilter={hidePastEventsFilter}
              />
              <a
                className={cx(
                  'utk-button-primary',
                  'adc-calendar-flyout-close'
                )}
                data-elm-id='calendar_flyout_close'
                onClick={this.clearFilters}
              >
                {STATICS.CLEAR_FILTER}
              </a>
            </Drawer>
          </MobileOnly>
        </div>
        <div className={cx('desktop-only')}>
          <CalendarFilters
            elmId='desktop'
            onChangeHandler={this.onChangeHandler}
            productTypeFilter={productTypeFilter}
            buyingTypeFilter={buyingTypeFilter}
            bidEndDateFilter={bidEndDateFilter}
            stateFilter={stateFilter}
            hidePastEventsFilter={hidePastEventsFilter}
          />
        </div>
      </div>
    )
  }
}

export default CalendarHeader
